module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Snare Cross Stick-189fdf3ad26dc6db42f230e97f659a02.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Snare Cross Stick.mp3
// module id = 59
// module chunks = 0